/*
  zp-upsell — behavior for the free-shipping bar + cart cross-sell (snippets/zp-upsell.liquid)
  and the PDP bundle-kits one-click add (sections/product__bundle-kits.liquid).

  1. Delegated [data-zp-add] click → POST /cart/add.js with a hidden line-item property
     properties[_zp_source] (crosssell | crosssell-kit | bundle-kits) — this persists onto
     the order line and is the revenue-attribution backbone (see docs/roi-baseline.md).
     On the cart page we reload (jsCart only patches subtotal nodes); everywhere else we
     let jsAjaxCart re-render the drawer/mini-cart, which re-renders the snippet server-side.
  2. Cart-page bar refresh: quantity changes on /cart go through /cart/change.js but never
     re-render our node, so we listen via ajaxComplete and patch the bar in place.
  3. dataLayer events (GTM GTM-NQ5JVCLB; same convention as zp-quiz-v2.js zpq_* events —
     tag/trigger setup documented in docs/gtm-setup.md):
       zpu_impression       {source, placement, handle, variant_id}  card ≥50% visible,
                            deduped per source+variant per page load (IntersectionObserver)
       zpu_add              {source, placement, handle, variant_id, price}  add.js success
       zpu_add_error        {source, placement, variant_id, status}  add.js failure
       zpu_freeship_reached {placement}  bar reaches done state, once per session
*/
(function ($) {
  if (window.__zpUpsell) return;
  window.__zpUpsell = true;

  function zpTrack(event, data) {
    var payload = $.extend({ event: event }, data || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  /* ---- one-click add ---- */

  $(document).on('click', '[data-zp-add]', function (e) {
    e.preventDefault();
    var $btn = $(this);
    if ($btn.prop('disabled')) return;
    $btn.prop('disabled', true);
    $btn.siblings('.zp-upsell__error').remove();

    var source = $btn.data('zp-source') || 'upsell';
    var placement = $btn.data('zp-placement') || '';
    var variantId = $btn.data('zp-add');
    var payload = { id: variantId, quantity: 1 };
    payload['properties[_zp_source]'] = source;

    $.post('/cart/add.js', payload, null, 'json')
      .done(function (resp) {
        zpTrack('zpu_add', {
          source: source,
          placement: placement,
          handle: $btn.data('zp-handle') || (resp && resp.handle) || '',
          variant_id: variantId,
          price: (resp && resp.price) || null
        });
        if ($('#cart_form').length) {
          // give GTM a beat to fire the event before unload
          setTimeout(function () { window.location.reload(); }, 200);
          return;
        }
        if (Shopify.theme.jsAjaxCart) {
          Shopify.theme.jsAjaxCart.updateView();
          Shopify.theme.jsAjaxCart.showDrawer(); // no-op in mini_cart mode
        }
        $('[data-ajax-cart-trigger]').addClass('show-mini-cart');
      })
      .fail(function (xhr) {
        zpTrack('zpu_add_error', {
          source: source,
          placement: placement,
          variant_id: variantId,
          status: xhr && xhr.status
        });
        var $err = $('<span class="zp-upsell__error" role="alert">Riprova</span>');
        $btn.after($err);
        setTimeout(function () { $err.remove(); }, 4000);
      })
      .always(function () {
        $btn.prop('disabled', false);
      });
  });

  /* ---- impressions ---- */

  var zpSeen = {};
  var zpPending = [];
  var zpPendingTimer = null;

  // IntersectionObserver is geometry-only: the mini-cart/drawer hides via
  // visibility/opacity, so an intersecting card can still be invisible.
  function zpVisible(el) {
    if (!el.isConnected) return false;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    if (r.bottom < 0 || r.top > window.innerHeight || r.right < 0 || r.left > window.innerWidth) return false;
    var n = el;
    while (n && n !== document.body) {
      var s = getComputedStyle(n);
      if (s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity) === 0) return false;
      n = n.parentElement;
    }
    return true;
  }

  function zpCheckPending() {
    if (!zpPending.length) return;
    zpPending = zpPending.filter(function (el) {
      if (!el.isConnected) return false;
      if (zpVisible(el)) { zpFireImpression(el); return false; }
      return true;
    });
  }

  // the drawer only becomes visible through user interaction — recheck after it
  function zpSchedulePendingCheck() {
    if (!zpPending.length || zpPendingTimer) return;
    zpPendingTimer = setTimeout(function () { zpPendingTimer = null; zpCheckPending(); }, 400);
  }

  var zpObserver = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          zpObserver.unobserve(entry.target);
          if (zpVisible(entry.target)) {
            zpFireImpression(entry.target);
          } else {
            zpPending.push(entry.target);
          }
        });
      }, { threshold: 0.5 })
    : null;

  function zpFireImpression(el) {
    var $el = $(el);
    var key = ($el.data('zp-source') || '') + ':' + ($el.data('zp-variant') || $el.data('zp-handle') || '');
    if (zpSeen[key]) return;
    zpSeen[key] = true;
    zpTrack('zpu_impression', {
      source: $el.data('zp-source') || '',
      placement: $el.data('zp-placement') || '',
      handle: $el.data('zp-handle') || '',
      variant_id: $el.data('zp-variant') || null
    });
  }

  function zpScanImpressions() {
    $('[data-zp-crosssell], [data-zp-bundle-card]').each(function () {
      if (this.__zpObserved) return;
      this.__zpObserved = true;
      if (zpObserver) {
        zpObserver.observe(this);
      } else {
        zpFireImpression(this);
      }
    });
  }

  /* ---- free-shipping bar ---- */

  function zpFireFreeshipReached(placement) {
    try {
      if (sessionStorage.getItem('zpu_fs_reached')) return;
      sessionStorage.setItem('zpu_fs_reached', '1');
    } catch (err) { /* private mode — fire untracked */ }
    zpTrack('zpu_freeship_reached', { placement: placement || '' });
  }

  function zpCheckReachedState() {
    var $done = $('[data-zp-freeship].zp-freeship--done').first();
    if ($done.length && !$done.prop('hidden')) {
      zpFireFreeshipReached($done.data('zp-context'));
    }
  }

  function zpRefreshBars(total) {
    $('[data-zp-freeship]').each(function () {
      var $el = $(this);
      var threshold = parseInt($el.data('zp-threshold'), 10);
      var floor = parseInt($el.data('zp-floor'), 10);
      var remaining = threshold - total;

      $el.prop('hidden', total < floor).toggleClass('zp-freeship--done', remaining <= 0);
      $el.find('[data-zp-freeship-bar]').css('width', Math.min(100, (total * 100) / threshold) + '%');

      var msg;
      if (remaining <= 0) {
        msg = $el.data('zp-copy-reached');
        if (total >= floor) zpFireFreeshipReached($el.data('zp-context'));
        // a kit pitched to bridge a now-closed gap is stale — hide it (singles stay);
        // no re-show if the gap re-opens: accepted limitation, reload resolves it
        $('[data-zp-crosssell][data-zp-mode="kit"]').prop('hidden', true);
      } else {
        var amount = Shopify.formatMoney
          ? Shopify.formatMoney(remaining, (window.Currency && Currency.money_format) || '€{{amount}}')
          : '€' + (remaining / 100).toFixed(2);
        msg = String($el.data('zp-copy-progress')).replace('[amount]', '<strong><span class="money">' + amount + '</span></strong>');
      }
      $el.find('[data-zp-freeship-msg]').html(msg);
    });
  }

  /* ---- wiring ---- */

  $(document).ajaxComplete(function (event, xhr, ajaxSettings) {
    // drawer re-renders (GET /cart?view=ajax) insert fresh cards — rescan after any ajax
    setTimeout(function () {
      zpScanImpressions();
      zpCheckPending();
      zpCheckReachedState();
    }, 0);

    if (!ajaxSettings || !ajaxSettings.url || ajaxSettings.url.indexOf('/cart/change') !== 0) return;
    if (!$('[data-zp-freeship][data-zp-context="cart"]').length) return;
    $.getJSON('/cart.js', function (cart) {
      zpRefreshBars(cart.total_price);
    });
  });

  $(document).on('click mouseover touchstart', zpSchedulePendingCheck);

  $(function () {
    zpScanImpressions();
    zpCheckReachedState();
  });
})(jQuery);
